import { inject, Injectable } from '@angular/core';
import { LfPaginatorIntlService } from '@leafio/ui/paginator';
import { LfTranslateService } from '@leafio/ui/i18n';

@Injectable()
export class PaginatorIntl extends LfPaginatorIntlService {
  protected translateService = inject(LfTranslateService);

  protected rowsKey = '2_0.PAGINATOR.rows';
  protected ofKey = '2_0.PAGINATOR.of';

  override rows = this.translateService.t(this.rowsKey);
  override of = this.translateService.t(this.ofKey);
}
